import { render } from "./ShokushuRegisterItem.vue?vue&type=template&id=63866cda&scoped=true&ts=true"
import script from "./ShokushuRegisterItem.vue?vue&type=script&lang=ts"
export * from "./ShokushuRegisterItem.vue?vue&type=script&lang=ts"

import "./ShokushuRegisterItem.vue?vue&type=style&index=0&id=63866cda&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63866cda"]])

export default __exports__